module.exports = "/_next/static/images/f353b32ea7728434b6665c384ea4fe69-open-graph-logo.png";